const clearPersistedFilters = (userId) => {
  window.localStorage.removeItem('tags-1');
  window.localStorage.removeItem('tags-2');
  const { length } = window.localStorage;
  for (let i = 0; i < length; i++) {
    const key = window.localStorage.key(i);
    if (key && key.startsWith('tags-') && key.endsWith(userId)) {
      window.localStorage.removeItem(key);
    }
  }
};

export default clearPersistedFilters;
